export default "__VITE_ASSET__tdvjMHr$__"